import initialState from '../../../../store/initialState';
import * as types from "../services/dropdownMgmtActionType";

const dropdownMgmtReducer = (state = initialState.dropdownMgmt, action) => {
  switch (action.type) {
    //RAD Type cases
    case types.FETCH_RADTYPES_REQUEST:
      return { ...state, isRadTypeLoading: true };
    case types.FETCH_RADTYPES_SUCCESS:
      return {
        ...state,
        isRadTypeLoading: false,
        radTypes: action.payload?.lstRadType,
      };
    case types.FETCH_RADTYPES_FAILURE:
      return { ...state, isRadTypeLoading: false, radTypes: [] };

    case types.DELETE_RADTYPE_REQUEST:
      return { ...state, isRadTypeLoading: true };
    case types.DELETE_RADTYPE_SUCCESS:
      return { ...state, isRadTypeLoading: false };
    case types.DELETE_RADTYPE_FAILURE:
      return { ...state, isRadTypeLoading: false };

    case types.SAVE_RADTYPE_REQUEST:
      return { ...state, isRadTypeLoading: true };
    case types.SAVE_RADTYPE_SUCCESS:
      return { ...state, isRadTypeLoading: false };
    case types.SAVE_RADTYPE_FAILURE:
      return { ...state, isRadTypeLoading: false };

    case types.FETCH_RADTYPE_BY_ID_REQUEST:
      return { ...state, isRadTypeLoading: true };
    case types.FETCH_RADTYPE_BY_ID_SUCCESS:
      return {
        ...state,
        isRadTypeLoading: false,
        selectedRadType: action.payload,
      };
    case types.FETCH_RADTYPE_BY_ID_FAILURE:
      return { ...state, isRadTypeLoading: false, selectedRadType: null };

    case types.UPDATE_RADTYPE_REQUEST:
      return { ...state, isRadTypeLoading: true };
    case types.UPDATE_RADTYPE_SUCCESS:
      return { ...state, isRadTypeLoading: false, selectedRadType: null };
    case types.UPDATE_RADTYPE_FAILURE:
      return { ...state, isRadTypeLoading: false };

    case types.ACTIVATE_DEACTIVATE_RADTYPE_REQUEST:
      return { ...state, isRadTypeLoading: true };
    case types.ACTIVATE_DEACTIVATE_RADTYPE_SUCCESS:
      return { ...state, isRadTypeLoading: false };
    case types.ACTIVATE_DEACTIVATE_RADTYPE_FAILURE:
      return { ...state, isRadTypeLoading: false };

    //RAD Status cases
    case types.FETCH_RADSTATUS_REQUEST:
      return { ...state, isRadStatusLoading: true };
    case types.FETCH_RADSTATUS_SUCCESS:
      return {
        ...state,
        isRadStatusLoading: false,
        radStatus: action.payload?.listRadStatus,
      };
    case types.FETCH_RADSTATUS_FAILURE:
      return { ...state, isRadStatusLoading: false, radStatus: [] };

    case types.DELETE_RADSTATUS_REQUEST:
      return { ...state, isRadStatusLoading: true };
    case types.DELETE_RADSTATUS_SUCCESS:
      return { ...state, isRadStatusLoading: false };
    case types.DELETE_RADSTATUS_FAILURE:
      return { ...state, isRadStatusLoading: false };

    case types.SAVE_RADSTATUS_REQUEST:
      return { ...state, isRadStatusLoading: true };
    case types.SAVE_RADSTATUS_SUCCESS:
      return { ...state, isRadStatusLoading: false };
    case types.SAVE_RADSTATUS_FAILURE:
      return { ...state, isRadStatusLoading: false };

    case types.FETCH_RADSTATUS_BY_ID_REQUEST:
      return { ...state, isRadStatusLoading: true };
    case types.FETCH_RADSTATUS_BY_ID_SUCCESS:
      return {
        ...state,
        isRadStatusLoading: false,
        selectedRadStatus: action.payload,
      };
    case types.FETCH_RADSTATUS_BY_ID_FAILURE:
      return { ...state, isRadStatusLoading: false, selectedRadStatus: null };

    case types.UPDATE_RADSTATUS_REQUEST:
      return { ...state, isRadStatusLoading: true };
    case types.UPDATE_RADSTATUS_SUCCESS:
      return { ...state, isRadStatusLoading: false, selectedRadStatus: null };
    case types.UPDATE_RADSTATUS_FAILURE:
      return { ...state, isRadStatusLoading: false };

    case types.ACTIVATE_DEACTIVATE_RADSTATUS_REQUEST:
      return { ...state, isRadStatusLoading: true };
    case types.ACTIVATE_DEACTIVATE_RADSTATUS_SUCCESS:
      return { ...state, isRadStatusLoading: false };
    case types.ACTIVATE_DEACTIVATE_RADSTATUS_FAILURE:
      return { ...state, isRadStatusLoading: false };

    // Subspeciality cases
    case types.FETCH_SUBSPECIALITIES_REQUEST:
      return { ...state, isSubspecialityLoading: true };
    case types.FETCH_SUBSPECIALITIES_SUCCESS:
      return {
        ...state,
        isSubspecialityLoading: false,
        subspecialities: action.payload?.listSubSpeciality || [],
      };
    case types.FETCH_SUBSPECIALITIES_FAILURE:
      return { ...state, isSubspecialityLoading: false, subspecialities: [] };

    case types.FETCH_SUBSPECIALITY_BY_ID_REQUEST:
      return { ...state, isSubspecialityLoading: true };
    case types.FETCH_SUBSPECIALITY_BY_ID_SUCCESS:
      return {
        ...state,
        isSubspecialityLoading: false,
        selectedSubspeciality: action.payload,
      };
    case types.FETCH_SUBSPECIALITY_BY_ID_FAILURE:
      return {
        ...state,
        isSubspecialityLoading: false,
        selectedSubspeciality: null,
      };

    case types.SAVE_SUBSPECIALITY_REQUEST:
      return { ...state, isSubspecialityLoading: true };
    case types.SAVE_SUBSPECIALITY_SUCCESS:
      return { ...state, isSubspecialityLoading: false };
    case types.SAVE_SUBSPECIALITY_FAILURE:
      return { ...state, isSubspecialityLoading: false };

    case types.DELETE_SUBSPECIALITY_REQUEST:
      return { ...state, isSubspecialityLoading: true };
    case types.DELETE_SUBSPECIALITY_SUCCESS:
      return { ...state, isSubspecialityLoading: false };
    case types.DELETE_SUBSPECIALITY_FAILURE:
      return { ...state, isSubspecialityLoading: false };

    case types.ACTIVATE_DEACTIVATE_SUBSPECIALITY_REQUEST:
      return { ...state, isSubspecialityLoading: true };
    case types.ACTIVATE_DEACTIVATE_SUBSPECIALITY_SUCCESS:
      return { ...state, isSubspecialityLoading: false };
    case types.ACTIVATE_DEACTIVATE_SUBSPECIALITY_FAILURE:
      return { ...state, isSubspecialityLoading: false };

    // Billing Management cases
    case types.FETCH_BILLING_MANAGEMENT_REQUEST:
      return { ...state, isBillingManagementLoading: true };
    case types.FETCH_BILLING_MANAGEMENT_SUCCESS:
      return {
        ...state,
        isBillingManagementLoading: false,
        billingManagement: action.payload?.listBillingManagement || [],
      };
    case types.FETCH_BILLING_MANAGEMENT_FAILURE:
      return {
        ...state,
        isBillingManagementLoading: false,
        billingManagement: [],
      };

    case types.FETCH_BILLING_MANAGEMENT_BY_ID_REQUEST:
      return { ...state, isBillingManagementLoading: true };
    case types.FETCH_BILLING_MANAGEMENT_BY_ID_SUCCESS:
      return {
        ...state,
        isBillingManagementLoading: false,
        selectedBillingManagement: action.payload,
      };
    case types.FETCH_BILLING_MANAGEMENT_BY_ID_FAILURE:
      return {
        ...state,
        isBillingManagementLoading: false,
        selectedBillingManagement: null,
      };

    case types.SAVE_BILLING_MANAGEMENT_REQUEST:
      return { ...state, isBillingManagementLoading: true };
    case types.SAVE_BILLING_MANAGEMENT_SUCCESS:
      return { ...state, isBillingManagementLoading: false };
    case types.SAVE_BILLING_MANAGEMENT_FAILURE:
      return { ...state, isBillingManagementLoading: false };

    case types.DELETE_BILLING_MANAGEMENT_REQUEST:
      return { ...state, isBillingManagementLoading: true };
    case types.DELETE_BILLING_MANAGEMENT_SUCCESS:
      return { ...state, isBillingManagementLoading: false };
    case types.DELETE_BILLING_MANAGEMENT_FAILURE:
      return { ...state, isBillingManagementLoading: false };

    case types.ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_REQUEST:
      return { ...state, isBillingManagementLoading: true };
    case types.ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_SUCCESS:
      return { ...state, isBillingManagementLoading: false };
    case types.ACTIVATE_DEACTIVATE_BILLING_MANAGEMENT_FAILURE:
      return { ...state, isBillingManagementLoading: false };

    // Week Rotation cases
    case types.FETCH_WEEK_ROTATIONS_REQUEST:
      return { ...state, isWeekRotationLoading: true };
    case types.FETCH_WEEK_ROTATIONS_SUCCESS:
      return {
        ...state,
        isWeekRotationLoading: false,
        weekRotations: action.payload?.listWeekRotation || action.payload || [],
      };
    case types.FETCH_WEEK_ROTATIONS_FAILURE:
      return { ...state, isWeekRotationLoading: false, weekRotations: [] };

    case types.FETCH_WEEK_ROTATION_BY_ID_REQUEST:
      return { ...state, isWeekRotationLoading: true };
    case types.FETCH_WEEK_ROTATION_BY_ID_SUCCESS:
      return {
        ...state,
        isWeekRotationLoading: false,
        selectedWeekRotation: action.payload,
      };
    case types.FETCH_WEEK_ROTATION_BY_ID_FAILURE:
      return {
        ...state,
        isWeekRotationLoading: false,
        selectedWeekRotation: null,
      };

    case types.DELETE_WEEK_ROTATION_REQUEST:
      return { ...state, isWeekRotationLoading: true };
    case types.DELETE_WEEK_ROTATION_SUCCESS:
      return { ...state, isWeekRotationLoading: false };
    case types.DELETE_WEEK_ROTATION_FAILURE:
      return { ...state, isWeekRotationLoading: false };

    case types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_REQUEST:
      return { ...state, isWeekRotationLoading: true };
    case types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_SUCCESS:
      return { ...state, isWeekRotationLoading: false };
    case types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_FAILURE:
      return { ...state, isWeekRotationLoading: false };

    case types.SAVE_WEEK_ROTATION_REQUEST:
      return { ...state, isWeekRotationLoading: true };
    case types.SAVE_WEEK_ROTATION_SUCCESS:
      return { ...state, isWeekRotationLoading: false };
    case types.SAVE_WEEK_ROTATION_FAILURE:
      return { ...state, isWeekRotationLoading: false };

    // Week Rotation Template cases
    case types.FETCH_WEEK_ROTATION_TEMPLATES_REQUEST:
      return { ...state, isWeekRotationTemplateLoading: true };
    case types.FETCH_WEEK_ROTATION_TEMPLATES_SUCCESS:
      return {
        ...state,
        isWeekRotationTemplateLoading: false,
        weekRotationTemplates: action.payload?.values || action.payload || [],
      };
    case types.FETCH_WEEK_ROTATION_TEMPLATES_FAILURE:
      return {
        ...state,
        isWeekRotationTemplateLoading: false,
        weekRotationTemplates: [],
      };

    case types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST:
      return { ...state, isWeekRotationTemplateLoading: true };
    case types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_SUCCESS:
      return {
        ...state,
        isWeekRotationTemplateLoading: false,
        selectedWeekRotationTemplate: action.payload,
      };
    case types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_FAILURE:
      return {
        ...state,
        isWeekRotationTemplateLoading: false,
        selectedWeekRotationTemplate: null,
      };

    case types.DELETE_WEEK_ROTATION_TEMPLATE_REQUEST:
      return { ...state, isWeekRotationTemplateLoading: true };
    case types.DELETE_WEEK_ROTATION_TEMPLATE_SUCCESS:
      return { ...state, isWeekRotationTemplateLoading: false };
    case types.DELETE_WEEK_ROTATION_TEMPLATE_FAILURE:
      return { ...state, isWeekRotationTemplateLoading: false };

    case types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_REQUEST:
      return { ...state, isWeekRotationTemplateLoading: true };
    case types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_SUCCESS:
      return { ...state, isWeekRotationTemplateLoading: false };
    case types.ACTIVATE_DEACTIVATE_WEEK_ROTATION_TEMPLATE_FAILURE:
      return { ...state, isWeekRotationTemplateLoading: false };

    case types.SAVE_WEEK_ROTATION_TEMPLATE_REQUEST:
      return { ...state, isWeekRotationTemplateLoading: true };
    case types.SAVE_WEEK_ROTATION_TEMPLATE_SUCCESS:
      return { ...state, isWeekRotationTemplateLoading: false };
    case types.SAVE_WEEK_ROTATION_TEMPLATE_FAILURE:
      return { ...state, isWeekRotationTemplateLoading: false };

    // Partnership Rate cases
    case types.FETCH_PARTNERSHIP_RATES_REQUEST:
      return { ...state, isPartnershipRateLoading: true };
    case types.FETCH_PARTNERSHIP_RATES_SUCCESS:
      return {
        ...state,
        isPartnershipRateLoading: false,
        partnershipRates:
          action.payload?.listRadPartnershipRate || action.payload || [],
      };
    case types.FETCH_PARTNERSHIP_RATES_FAILURE:
      return {
        ...state,
        isPartnershipRateLoading: false,
        partnershipRates: [],
      };

    case types.FETCH_PARTNERSHIP_RATE_BY_ID_REQUEST:
      return { ...state, isPartnershipRateLoading: true };
    case types.FETCH_PARTNERSHIP_RATE_BY_ID_SUCCESS:
      return {
        ...state,
        isPartnershipRateLoading: false,
        selectedPartnershipRate: action.payload,
      };
    case types.FETCH_PARTNERSHIP_RATE_BY_ID_FAILURE:
      return {
        ...state,
        isPartnershipRateLoading: false,
        selectedPartnershipRate: null,
      };

    case types.SAVE_PARTNERSHIP_RATE_REQUEST:
      return { ...state, isPartnershipRateLoading: true };
    case types.SAVE_PARTNERSHIP_RATE_SUCCESS:
      return { ...state, isPartnershipRateLoading: false };
    case types.SAVE_PARTNERSHIP_RATE_FAILURE:
      return { ...state, isPartnershipRateLoading: false };

    case types.DELETE_PARTNERSHIP_RATE_REQUEST:
      return { ...state, isPartnershipRateLoading: true };
    case types.DELETE_PARTNERSHIP_RATE_SUCCESS:
      return { ...state, isPartnershipRateLoading: false };
    case types.DELETE_PARTNERSHIP_RATE_FAILURE:
      return { ...state, isPartnershipRateLoading: false };

    case types.ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_REQUEST:
      return { ...state, isPartnershipRateLoading: true };
    case types.ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_SUCCESS:
      return { ...state, isPartnershipRateLoading: false };
    case types.ACTIVATE_DEACTIVATE_PARTNERSHIP_RATE_FAILURE:
      return { ...state, isPartnershipRateLoading: false };

    // Partnership Status cases
    case types.FETCH_PARTNERSHIP_STATUSES_REQUEST:
      return { ...state, isPartnershipStatusLoading: true };
    case types.FETCH_PARTNERSHIP_STATUSES_SUCCESS:
      return {
        ...state,
        isPartnershipStatusLoading: false,
        partnershipStatuses:
          action.payload?.listRadPartnershipStatus || action.payload || [],
      };
    case types.FETCH_PARTNERSHIP_STATUSES_FAILURE:
      return {
        ...state,
        isPartnershipStatusLoading: false,
        partnershipStatuses: [],
      };

    case types.FETCH_PARTNERSHIP_STATUS_BY_ID_REQUEST:
      return { ...state, isPartnershipStatusLoading: true };
    case types.FETCH_PARTNERSHIP_STATUS_BY_ID_SUCCESS:
      return {
        ...state,
        isPartnershipStatusLoading: false,
        selectedPartnershipStatus: action.payload,
      };
    case types.FETCH_PARTNERSHIP_STATUS_BY_ID_FAILURE:
      return {
        ...state,
        isPartnershipStatusLoading: false,
        selectedPartnershipStatus: null,
      };

    case types.SAVE_PARTNERSHIP_STATUS_REQUEST:
      return { ...state, isPartnershipStatusLoading: true };
    case types.SAVE_PARTNERSHIP_STATUS_SUCCESS:
      return { ...state, isPartnershipStatusLoading: false };
    case types.SAVE_PARTNERSHIP_STATUS_FAILURE:
      return { ...state, isPartnershipStatusLoading: false };

    case types.DELETE_PARTNERSHIP_STATUS_REQUEST:
      return { ...state, isPartnershipStatusLoading: true };
    case types.DELETE_PARTNERSHIP_STATUS_SUCCESS:
      return { ...state, isPartnershipStatusLoading: false };
    case types.DELETE_PARTNERSHIP_STATUS_FAILURE:
      return { ...state, isPartnershipStatusLoading: false };

    case types.ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_REQUEST:
      return { ...state, isPartnershipStatusLoading: true };
    case types.ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_SUCCESS:
      return { ...state, isPartnershipStatusLoading: false };
    case types.ACTIVATE_DEACTIVATE_PARTNERSHIP_STATUS_FAILURE:
      return { ...state, isPartnershipStatusLoading: false };

    // Partnership Time cases
    case types.FETCH_PARTNERSHIP_TIMES_REQUEST:
      return { ...state, isPartnershipTimeLoading: true };
    case types.FETCH_PARTNERSHIP_TIMES_SUCCESS:
      return {
        ...state,
        isPartnershipTimeLoading: false,
        partnershipTimes:
          action.payload?.listRadPartnershipTime || action.payload || [],
      };
    case types.FETCH_PARTNERSHIP_TIMES_FAILURE:
      return {
        ...state,
        isPartnershipTimeLoading: false,
        partnershipTimes: [],
      };

    case types.FETCH_PARTNERSHIP_TIME_BY_ID_REQUEST:
      return { ...state, isPartnershipTimeLoading: true };
    case types.FETCH_PARTNERSHIP_TIME_BY_ID_SUCCESS:
      return {
        ...state,
        isPartnershipTimeLoading: false,
        selectedPartnershipTime: action.payload,
      };
    case types.FETCH_PARTNERSHIP_TIME_BY_ID_FAILURE:
      return {
        ...state,
        isPartnershipTimeLoading: false,
        selectedPartnershipTime: null,
      };

    case types.SAVE_PARTNERSHIP_TIME_REQUEST:
      return { ...state, isPartnershipTimeLoading: true };
    case types.SAVE_PARTNERSHIP_TIME_SUCCESS:
      return { ...state, isPartnershipTimeLoading: false };
    case types.SAVE_PARTNERSHIP_TIME_FAILURE:
      return { ...state, isPartnershipTimeLoading: false };

    case types.DELETE_PARTNERSHIP_TIME_REQUEST:
      return { ...state, isPartnershipTimeLoading: true };
    case types.DELETE_PARTNERSHIP_TIME_SUCCESS:
      return { ...state, isPartnershipTimeLoading: false };
    case types.DELETE_PARTNERSHIP_TIME_FAILURE:
      return { ...state, isPartnershipTimeLoading: false };

    case types.ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_REQUEST:
      return { ...state, isPartnershipTimeLoading: true };
    case types.ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_SUCCESS:
      return { ...state, isPartnershipTimeLoading: false };
    case types.ACTIVATE_DEACTIVATE_PARTNERSHIP_TIME_FAILURE:
      return { ...state, isPartnershipTimeLoading: false };

    //radDegree cases - START
    case types.FETCH_RAD_DEGREE_REQUEST:
      return { ...state, isRadDegreeLoading: true };
    case types.FETCH_RAD_DEGREE_SUCCESS:
      return {
        ...state,
        isRadDegreeLoading: false,
        radDegree: action.payload?.lstRadDegree || [],
      };
    case types.FETCH_RAD_DEGREE_FAILURE:
      return { ...state, isRadDegreeLoading: false, radDegree: [] };

    case types.DELETE_RAD_DEGREE_REQUEST:
      return { ...state, isRadDegreeLoading: true };
    case types.DELETE_RAD_DEGREE_SUCCESS:
      return { ...state, isRadDegreeLoading: false };
    case types.DELETE_RAD_DEGREE_FAILURE:
      return { ...state, isRadDegreeLoading: false };

    case types.SAVE_RAD_DEGREE_REQUEST:
      return { ...state, isRadDegreeLoading: true };
    case types.SAVE_RAD_DEGREE_SUCCESS:
      return { ...state, isRadDegreeLoading: false };
    case types.SAVE_RAD_DEGREE_FAILURE:
      return { ...state, isRadDegreeLoading: false };

    case types.FETCH_RAD_DEGREE_BY_ID_REQUEST:
      return { ...state, isRadDegreeLoading: true };
    case types.FETCH_RAD_DEGREE_BY_ID_SUCCESS:
      return {
        ...state,
        isRadDegreeLoading: false,
        selectedRadDegree: action.payload,
      };
    case types.FETCH_RAD_DEGREE_BY_ID_FAILURE:
      return { ...state, isRadDegreeLoading: false, selectedRadDegree: null };

    case types.ACTIVATE_DEACTIVATE_RAD_DEGREE_REQUEST:
      return { ...state, isRadDegreeLoading: true };
    case types.ACTIVATE_DEACTIVATE_RAD_DEGREE_SUCCESS:
      return { ...state, isRadDegreeLoading: false };
    case types.ACTIVATE_DEACTIVATE_RAD_DEGREE_FAILURE:
      return { ...state, isRadDegreeLoading: false };
    //radDegree cases - END

    //designationLookup cases - START
    case types.FETCH_DESIGNATION_LOOKUP_REQUEST:
      return { ...state };
    case types.FETCH_DESIGNATION_LOOKUP_SUCCESS:
      return {
        ...state,
        designationLookup: action.payload || [],
      };
    case types.FETCH_DESIGNATION_LOOKUP_FAILURE:
      return { ...state, designationLookup: [] };
    //designationLookup cases - END

    //designation cases - START
    case types.FETCH_DESIGNATION_REQUEST:
      return { ...state, isDesignationLoading: true };
    case types.FETCH_DESIGNATION_SUCCESS:
      return {
        ...state,
        isDesignationLoading: false,
        designation: action.payload?.lstDesignationUser || [],
      };
    case types.FETCH_DESIGNATION_FAILURE:
      return { ...state, isDesignationLoading: false, designation: [] };

    case types.DELETE_DESIGNATION_REQUEST:
      return { ...state, isDesignationLoading: true };
    case types.DELETE_DESIGNATION_SUCCESS:
      return { ...state, isDesignationLoading: false };
    case types.DELETE_DESIGNATION_FAILURE:
      return { ...state, isDesignationLoading: false };

    case types.SAVE_DESIGNATION_REQUEST:
      return { ...state, isDesignationLoading: true };
    case types.SAVE_DESIGNATION_SUCCESS:
      return { ...state, isDesignationLoading: false };
    case types.SAVE_DESIGNATION_FAILURE:
      return { ...state, isDesignationLoading: false };

    case types.FETCH_DESIGNATION_BY_ID_REQUEST:
      return { ...state, isDesignationLoading: true };
    case types.FETCH_DESIGNATION_BY_ID_SUCCESS:
      return {
        ...state,
        isDesignationLoading: false,
        selectedDesignation: action.payload,
      };
    case types.FETCH_DESIGNATION_BY_ID_FAILURE:
      return { ...state, isDesignationLoading: false, selectedDesignation: null };

    case types.ACTIVATE_DEACTIVATE_DESIGNATION_REQUEST:
      return { ...state, isDesignationLoading: true };
    case types.ACTIVATE_DEACTIVATE_DESIGNATION_SUCCESS:
      return { ...state, isDesignationLoading: false };
    case types.ACTIVATE_DEACTIVATE_DESIGNATION_FAILURE:
      return { ...state, isDesignationLoading: false };
    //designation cases - END

    //committees cases - START
    case types.FETCH_COMMITTEES_REQUEST:
      return { ...state, isCommitteesLoading: true };
    case types.FETCH_COMMITTEES_SUCCESS:
      return {
        ...state,
        isCommitteesLoading: false,
        committees: action.payload?.lstRadCommittees || [],
      };
    case types.FETCH_COMMITTEES_FAILURE:
      return { ...state, isCommitteesLoading: false, committees: [] };

    case types.DELETE_COMMITTEES_REQUEST:
      return { ...state, isCommitteesLoading: true };
    case types.DELETE_COMMITTEES_SUCCESS:
      return { ...state, isCommitteesLoading: false };
    case types.DELETE_COMMITTEES_FAILURE:
      return { ...state, isCommitteesLoading: false };

    case types.SAVE_COMMITTEES_REQUEST:
      return { ...state, isCommitteesLoading: true };
    case types.SAVE_COMMITTEES_SUCCESS:
      return { ...state, isCommitteesLoading: false };
    case types.SAVE_COMMITTEES_FAILURE:
      return { ...state, isCommitteesLoading: false };

    case types.FETCH_COMMITTEES_BY_ID_REQUEST:
      return { ...state, isCommitteesLoading: true };
    case types.FETCH_COMMITTEES_BY_ID_SUCCESS:
      return {
        ...state,
        isCommitteesLoading: false,
        selectedCommittees: action.payload,
      };
    case types.FETCH_COMMITTEES_BY_ID_FAILURE:
      return { ...state, isCommitteesLoading: false, selectedCommittees: null };

    case types.ACTIVATE_DEACTIVATE_COMMITTEES_REQUEST:
      return { ...state, isCommitteesLoading: true };
    case types.ACTIVATE_DEACTIVATE_COMMITTEES_SUCCESS:
      return { ...state, isCommitteesLoading: false };
    case types.ACTIVATE_DEACTIVATE_COMMITTEES_FAILURE:
      return { ...state, isCommitteesLoading: false };
    //committees cases - END

    //Future Section Change cases - START
    case types.FETCH_FUTURE_SECTION_CHANGE_REQUEST:
      return { ...state, isFutureSectionChangeLoading: true };
    case types.FETCH_FUTURE_SECTION_CHANGE_SUCCESS:
      return {
        ...state,
        isFutureSectionChangeLoading: false,
        futureSectionChange: action.payload?.listRadScheduleFutureSection || [],
      };
    case types.FETCH_FUTURE_SECTION_CHANGE_FAILURE:
      return {
        ...state,
        isFutureSectionChangeLoading: false,
        futureSectionChange: [],
      };

    case types.DELETE_FUTURE_SECTION_CHANGE_REQUEST:
      return { ...state, isFutureSectionChangeLoading: true };
    case types.DELETE_FUTURE_SECTION_CHANGE_SUCCESS:
      return { ...state, isFutureSectionChangeLoading: false };
    case types.DELETE_FUTURE_SECTION_CHANGE_FAILURE:
      return { ...state, isFutureSectionChangeLoading: false };

    case types.SAVE_FUTURE_SECTION_CHANGE_REQUEST:
      return { ...state, isFutureSectionChangeLoading: true };
    case types.SAVE_FUTURE_SECTION_CHANGE_SUCCESS:
      return { ...state, isFutureSectionChangeLoading: false };
    case types.SAVE_FUTURE_SECTION_CHANGE_FAILURE:
      return { ...state, isFutureSectionChangeLoading: false };

    case types.FETCH_FUTURE_SECTION_CHANGE_BY_ID_REQUEST:
      return { ...state, isFutureSectionChangeLoading: true };
    case types.FETCH_FUTURE_SECTION_CHANGE_BY_ID_SUCCESS:
      return {
        ...state,
        isFutureSectionChangeLoading: false,
        selectedFutureSectionChange: action.payload,
      };
    case types.FETCH_FUTURE_SECTION_CHANGE_BY_ID_FAILURE:
      return {
        ...state,
        isFutureSectionChangeLoading: false,
        selectedFutureSectionChange: null,
      };

    case types.ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_REQUEST:
      return { ...state, isFutureSectionChangeLoading: true };
    case types.ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_SUCCESS:
      return { ...state, isFutureSectionChangeLoading: false };
    case types.ACTIVATE_DEACTIVATE_FUTURE_SECTION_CHANGE_FAILURE:
      return { ...state, isFutureSectionChangeLoading: false };
    //Future Section Change cases - END

    //ScheduleType cases
    case types.FETCH_SCHEDULETYPE_REQUEST:
      return { ...state, isScheduleTypeLoading: true };
    case types.FETCH_SCHEDULETYPE_SUCCESS:
      return {
        ...state,
        isScheduleTypeLoading: false,
        scheduleType: action.payload?.lstScheduleType || [],
      };
    case types.FETCH_SCHEDULETYPE_FAILURE:
      return { ...state, isScheduleTypeLoading: false, scheduleType: [] };

    case types.DELETE_SCHEDULETYPE_REQUEST:
      return { ...state, isScheduleTypeLoading: true };
    case types.DELETE_SCHEDULETYPE_SUCCESS:
      return { ...state, isScheduleTypeLoading: false };
    case types.DELETE_SCHEDULETYPE_FAILURE:
      return { ...state, isScheduleTypeLoading: false };

    case types.SAVE_SCHEDULETYPE_REQUEST:
      return { ...state, isScheduleTypeLoading: true };
    case types.SAVE_SCHEDULETYPE_SUCCESS:
      return { ...state, isScheduleTypeLoading: false };
    case types.SAVE_SCHEDULETYPE_FAILURE:
      return { ...state, isScheduleTypeLoading: false };

    case types.FETCH_SCHEDULETYPE_BY_ID_REQUEST:
      return { ...state, isScheduleTypeLoading: true };
    case types.FETCH_SCHEDULETYPE_BY_ID_SUCCESS:
      return {
        ...state,
        isScheduleTypeLoading: false,
        selectedScheduleType: action.payload,
      };
    case types.FETCH_SCHEDULETYPE_BY_ID_FAILURE:
      return {
        ...state,
        isScheduleTypeLoading: false,
        selectedScheduleType: null,
      };

    case types.ACTIVATE_DEACTIVATE_SCHEDULETYPE_REQUEST:
      return { ...state, isScheduleTypeLoading: true };
    case types.ACTIVATE_DEACTIVATE_SCHEDULETYPE_SUCCESS:
      return { ...state, isScheduleTypeLoading: false };
    case types.ACTIVATE_DEACTIVATE_SCHEDULETYPE_FAILURE:
      return { ...state, isScheduleTypeLoading: false };

    //RadCommunicationType cases
    case types.FETCH_RAD_COMMUNICATION_TYPE_REQUEST:
      return { ...state, isRadCommunicationTypeLoading: true };
    case types.FETCH_RAD_COMMUNICATION_TYPE_SUCCESS:
      return {
        ...state,
        isRadCommunicationTypeLoading: false,
        radCommunicationTypes: action.payload?.lstRadCommunicationType,
      };
    case types.FETCH_RAD_COMMUNICATION_TYPE_FAILURE:
      return {
        ...state,
        isRadCommunicationTypeLoading: false,
        radCommunicationTypes: [],
      };

    case types.DELETE_RAD_COMMUNICATION_TYPE_REQUEST:
      return { ...state, isRadCommunicationTypeLoading: true };
    case types.DELETE_RAD_COMMUNICATION_TYPE_SUCCESS:
      return { ...state, isRadCommunicationTypeLoading: false };
    case types.DELETE_RAD_COMMUNICATION_TYPE_FAILURE:
      return { ...state, isRadCommunicationTypeLoading: false };

    case types.SAVE_RAD_COMMUNICATION_TYPE_REQUEST:
      return { ...state, isRadCommunicationTypeLoading: true };
    case types.SAVE_RAD_COMMUNICATION_TYPE_SUCCESS:
      return { ...state, isRadCommunicationTypeLoading: false };
    case types.SAVE_RAD_COMMUNICATION_TYPE_FAILURE:
      return { ...state, isRadCommunicationTypeLoading: false };

    case types.FETCH_RAD_COMMUNICATION_TYPE_BY_ID_REQUEST:
      return { ...state, isRadCommunicationTypeLoading: true };
    case types.FETCH_RAD_COMMUNICATION_TYPE_BY_ID_SUCCESS:
      return {
        ...state,
        isRadCommunicationTypeLoading: false,
        selectedRadCommunicationType: action.payload,
      };
    case types.FETCH_RAD_COMMUNICATION_TYPE_BY_ID_FAILURE:
      return {
        ...state,
        isRadCommunicationTypeLoading: false,
        selectedRadCommunicationType: null,
      };

    case types.ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_REQUEST:
      return { ...state, isRadCommunicationTypeLoading: true };
    case types.ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_SUCCESS:
      return { ...state, isRadCommunicationTypeLoading: false };
    case types.ACTIVATE_DEACTIVATE_RAD_COMMUNICATION_TYPE_FAILURE:
      return { ...state, isRadCommunicationTypeLoading: false };

    //Qgenda cases

    case types.FETCH_QGENDA_SECTION_REQUEST:
      return { ...state, isQgendaSectionLoading: true };
    case types.FETCH_QGENDA_SECTION_SUCCESS:
      return {
        ...state,
        isQgendaSectionLoading: false,
        qgendaSections: action.payload?.lstRadQGendaSection || [],
      };
    case types.FETCH_QGENDA_SECTION_FAILURE:
      return { ...state, isQgendaSectionLoading: false, qgendaSections: [] };

    case types.FETCH_QGENDA_SECTION_BY_ID_REQUEST:
      return { ...state, isQgendaSectionLoading: true };
    case types.FETCH_QGENDA_SECTION_BY_ID_SUCCESS:
      return {
        ...state,
        isQgendaSectionLoading: false,
        selectedQgendaSection: action.payload,
      };
    case types.FETCH_QGENDA_SECTION_BY_ID_FAILURE:
      return {
        ...state,
        isQgendaSectionLoading: false,
        selectedQgendaSection: null,
      };

    case types.SAVE_QGENDA_SECTION_REQUEST:
      return { ...state, isQgendaSectionLoading: true };
    case types.SAVE_QGENDA_SECTION_SUCCESS:
      return { ...state, isQgendaSectionLoading: false };
    case types.SAVE_QGENDA_SECTION_FAILURE:
      return { ...state, isQgendaSectionLoading: false };

    case types.DELETE_QGENDA_SECTION_REQUEST:
      return { ...state, isQgendaSectionLoading: true };
    case types.DELETE_QGENDA_SECTION_SUCCESS:
      return { ...state, isQgendaSectionLoading: false };
    case types.DELETE_QGENDA_SECTION_FAILURE:
      return { ...state, isQgendaSectionLoading: false };

    case types.ACTIVATE_DEACTIVATE_QGENDA_SECTION_REQUEST:
      return { ...state, isQgendaSectionLoading: true };
    case types.ACTIVATE_DEACTIVATE_QGENDA_SECTION_SUCCESS:
      return { ...state, isQgendaSectionLoading: false };
    case types.ACTIVATE_DEACTIVATE_QGENDA_SECTION_FAILURE:
      return { ...state, isQgendaSectionLoading: false };

    //SiteStatus cases
    case types.FETCH_SITE_STATUS_REQUEST:
      return { ...state, isSiteStatusLoading: true };
    case types.FETCH_SITE_STATUS_SUCCESS:
      return {
        ...state,
        isSiteStatusLoading: false,
        siteStatuses: action.payload?.listSiteStatus || [],
      };
    case types.FETCH_SITE_STATUS_FAILURE:
      return { ...state, isSiteStatusLoading: false, siteStatuses: [] };

    case types.FETCH_SITE_STATUS_BY_ID_REQUEST:
      return { ...state, isSiteStatusLoading: true };
    case types.FETCH_SITE_STATUS_BY_ID_SUCCESS:
      return {
        ...state,
        isSiteStatusLoading: false,
        selectedSiteStatus: action.payload,
      };
    case types.FETCH_SITE_STATUS_BY_ID_FAILURE:
      return { ...state, isSiteStatusLoading: false, selectedSiteStatus: null };

    case types.SAVE_SITE_STATUS_REQUEST:
      return { ...state, isSiteStatusLoading: true };
    case types.SAVE_SITE_STATUS_SUCCESS:
      return { ...state, isSiteStatusLoading: false };
    case types.SAVE_SITE_STATUS_FAILURE:
      return { ...state, isSiteStatusLoading: false };

    case types.DELETE_SITE_STATUS_REQUEST:
      return { ...state, isSiteStatusLoading: true };
    case types.DELETE_SITE_STATUS_SUCCESS:
      return { ...state, isSiteStatusLoading: false };
    case types.DELETE_SITE_STATUS_FAILURE:
      return { ...state, isSiteStatusLoading: false };

    // RVURATE cases
    case types.FETCH_RVURATE_REQUEST:
      return { ...state, isRVURATELoading: true };
    case types.FETCH_RVURATE_SUCCESS:
      return {
        ...state,
        isRVURATELoading: false,
        RVURATE: action.payload || [],
      };
    case types.FETCH_RVURATE_FAILURE:
      return { ...state, isRVURATELoading: false, RVURATE: [] };
    case types.FETCH_RVURATE_BY_ID_REQUEST:
      return { ...state, isRVURATELoading: true };
    case types.FETCH_RVURATE_BY_ID_SUCCESS:
      return {
        ...state,
        isRVURATELoading: false,
        selectedRVURATE: action.payload,
      };
    case types.FETCH_RVURATE_BY_ID_FAILURE:
      return { ...state, isRVURATELoading: false, selectedRVURATE: null };
    case types.SAVE_RVURATE_REQUEST:
      return { ...state, isRVURATELoading: true };
    case types.SAVE_RVURATE_SUCCESS:
      return { ...state, isRVURATELoading: false };
    case types.SAVE_RVURATE_FAILURE:
      return { ...state, isRVURATELoading: false };
    case types.DELETE_RVURATE_REQUEST:
      return { ...state, isRVURATELoading: true };
    case types.DELETE_RVURATE_SUCCESS:
      return { ...state, isRVURATELoading: false };
    case types.DELETE_RVURATE_FAILURE:
      return { ...state, isRVURATELoading: false };
    case types.ACTIVATE_DEACTIVATE_RVURATE_REQUEST:
      return { ...state, isRVURATELoading: true };
    case types.ACTIVATE_DEACTIVATE_RVURATE_SUCCESS:
      return { ...state, isRVURATELoading: false };
    case types.ACTIVATE_DEACTIVATE_RVURATE_FAILURE:
      return { ...state, isRVURATELoading: false };
    case types.FETCH_TIME_ZONES_REQUEST:
      return { ...state, isTimeZoneLoading: true };
    case types.FETCH_TIME_ZONES_SUCCESS:
      return {
        ...state,
        isTimeZoneLoading: false,
        timeZones: action.payload || [],
      };
    case types.FETCH_TIME_ZONES_FAILURE:
      return { ...state, isTimeZoneLoading: false, timeZones: [] };
    case types.SAVE_TIME_ZONE_REQUEST:
      return { ...state, isTimeZoneLoading: true };
    case types.SAVE_TIME_ZONE_SUCCESS:
      return { ...state, isTimeZoneLoading: false };
    case types.SAVE_TIME_ZONE_FAILURE:
      return { ...state, isTimeZoneLoading: false };
    case types.DELETE_TIME_ZONE_REQUEST:
      return { ...state, isTimeZoneLoading: true };
    case types.DELETE_TIME_ZONE_SUCCESS:
      return { ...state, isTimeZoneLoading: false };
    case types.DELETE_TIME_ZONE_FAILURE:
      return { ...state, isTimeZoneLoading: false };
    case types.ACTIVATE_DEACTIVATE_TIME_ZONE_REQUEST:
      return { ...state, isTimeZoneLoading: true };
    case types.ACTIVATE_DEACTIVATE_TIME_ZONE_SUCCESS:
      return { ...state, isTimeZoneLoading: false };
    case types.ACTIVATE_DEACTIVATE_TIME_ZONE_FAILURE:
      return { ...state, isTimeZoneLoading: false };
    case types.FETCH_TIME_ZONE_BY_ID_REQUEST:
      return { ...state, isTimeZoneLoading: true };
    case types.FETCH_TIME_ZONE_BY_ID_SUCCESS:
      return {
        ...state,
        isTimeZoneLoading: false,
        selectedTimeZone: action.payload,
      };
    case types.FETCH_TIME_ZONE_BY_ID_FAILURE:
      return { ...state, isTimeZoneLoading: false, selectedTimeZone: null };

    // Request Status cases
    case types.FETCH_REQUESTSTATUS_REQUEST:
      return { ...state, isRequestStatusLoading: true };
    case types.FETCH_REQUESTSTATUS_SUCCESS:
      return {
        ...state,
        isRequestStatusLoading: false,
        RequestStatus: action.payload?.listScheduleRequestStatus || [],
      };
    case types.FETCH_REQUESTSTATUS_FAILURE:
      return { ...state, isRequestStatusLoading: false, RequestStatus: [] };

    case types.SAVE_REQUESTSTATUS_REQUEST:
      return { ...state, isRequestStatusLoading: true };
    case types.SAVE_REQUESTSTATUS_SUCCESS:
      return { ...state, isRequestStatusLoading: false };
    case types.SAVE_REQUESTSTATUS_FAILURE:
      return { ...state, isRequestStatusLoading: false };

    case types.FETCH_REQUESTSTATUS_BY_ID_REQUEST:
      return { ...state, isRequestStatusLoading: true };
    case types.FETCH_REQUESTSTATUS_BY_ID_SUCCESS:
      return {
        ...state,
        isRequestStatusLoading: false,
        selectedRequestStatus: action.payload,
      };
    case types.FETCH_REQUESTSTATUS_BY_ID_FAILURE:
      return { ...state, isRequestStatusLoading: false };

    case types.DELETE_REQUESTSTATUS_REQUEST:
      return { ...state, isRequestStatusLoading: true };
    case types.DELETE_REQUESTSTATUS_SUCCESS:
      return { ...state, isRequestStatusLoading: false };
    case types.DELETE_REQUESTSTATUS_FAILURE:
      return { ...state, isRequestStatusLoading: false };

    case types.ACTIVATE_DEACTIVATE_REQUEST_STATUS_REQUEST:
      return { ...state, isRequestStatusLoading: true };

    case types.ACTIVATE_DEACTIVATE_REQUEST_STATUS_SUCCESS:
      return { ...state, isRequestStatusLoading: false };
    case types.ACTIVATE_DEACTIVATE_REQUEST_STATUS_FAILURE:
      return { ...state, isRequestStatusLoading: false };

    //TraumaFacilityLevel cases
    case types.FETCH_TRAUMAFACILITYLEVEL_REQUEST:
      return { ...state, isTraumaFacilityLevelLoading: true };
    case types.FETCH_TRAUMAFACILITYLEVEL_SUCCESS:
      return {
        ...state,
        isTraumaFacilityLevelLoading: false,
        TraumaFacilityLevel: action.payload || [],
      };
    case types.FETCH_TRAUMAFACILITYLEVEL_FAILURE:
      return {
        ...state,
        isTraumaFacilityLevelLoading: false,
        TraumaFacilityLevel: [],
      };

    case types.DELETE_TRAUMAFACILITYLEVEL_REQUEST:
      return { ...state, isTraumaFacilityLevelLoading: true };
    case types.DELETE_TRAUMAFACILITYLEVEL_SUCCESS:
      return {
        ...state,
        isTraumaFacilityLevelLoading: false,
        TraumaFacilityLevel: state.TraumaFacilityLevel.filter(
          (item) => item.TramaFacilityLevelID !== action.payload,
        ),
      };
    case types.DELETE_TRAUMAFACILITYLEVEL_FAILURE:
      return { ...state, isTraumaFacilityLevelLoading: false };
    case types.ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_REQUEST:
      return { ...state, isTraumaFacilityLevelLoading: true };
    case types.ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_SUCCESS:
      return { ...state, isTraumaFacilityLevelLoading: false };
    case types.ACTIVATE_DEACTIVATE_TRAUMAFACILITYLEVEL_FAILURE:
      return { ...state, isTraumaFacilityLevelLoading: false };

    // Save Trauma Facility Level Cases
    case types.SAVE_TRAUMAFACILITYLEVEL_REQUEST:
      return { ...state, isTraumaFacilityLevelLoading: true };
    case types.SAVE_TRAUMAFACILITYLEVEL_SUCCESS:
      return { ...state, isTraumaFacilityLevelLoading: false };
    case types.SAVE_TRAUMAFACILITYLEVEL_FAILURE:
      return { ...state, isTraumaFacilityLevelLoading: false };

    // Fetch Trauma Facility Level By ID Cases
    case types.FETCH_TRAUMAFACILITYLEVEL_BY_ID_REQUEST:
      return { ...state, isTraumaFacilityLevelLoading: true };
    case types.FETCH_TRAUMAFACILITYLEVEL_BY_ID_SUCCESS:
      return {
        ...state,
        isTraumaFacilityLevelLoading: false,
        selectedTraumaFacilityLevel: action.payload,
      };
    case types.FETCH_TRAUMAFACILITYLEVEL_BY_ID_FAILURE:
      return { ...state, isTraumaFacilityLevelLoading: false };

    // Staff Category cases

    case types.FETCH_STAFF_CATEGORIES_REQUEST:
      return { ...state, isStaffCategoryLoading: true };
    case types.FETCH_STAFF_CATEGORIES_SUCCESS:
      return {
        ...state,
        isStaffCategoryLoading: false,
        staffCategories: action.payload || [],
      };
    case types.FETCH_STAFF_CATEGORIES_FAILURE:
      return { ...state, isStaffCategoryLoading: false, staffCategories: [] };

    case types.FETCH_STAFF_CATEGORY_BY_ID_REQUEST:
      return { ...state, isStaffCategoryLoading: true };
    case types.FETCH_STAFF_CATEGORY_BY_ID_SUCCESS:
      return {
        ...state,
        isStaffCategoryLoading: false,
        selectedStaffCategory: action.payload,
      };
    case types.FETCH_STAFF_CATEGORY_BY_ID_FAILURE:
      return { ...state, isStaffCategoryLoading: false };

    case types.SAVE_STAFF_CATEGORY_REQUEST:
      return { ...state, isStaffCategoryLoading: true };
    case types.SAVE_STAFF_CATEGORY_SUCCESS:
      return { ...state, isStaffCategoryLoading: false };
    case types.SAVE_STAFF_CATEGORY_FAILURE:
      return { ...state, isStaffCategoryLoading: false };

    case types.DELETE_STAFF_CATEGORY_REQUEST:
      return { ...state, isStaffCategoryLoading: true };
    case types.DELETE_STAFF_CATEGORY_SUCCESS:
      return { ...state, isStaffCategoryLoading: false };
    case types.DELETE_STAFF_CATEGORY_FAILURE:
      return { ...state, isStaffCategoryLoading: false };

    case types.ACTIVATE_DEACTIVATE_STAFF_CATEGORY_REQUEST:
      return { ...state, isStaffCategoryLoading: true };
    case types.ACTIVATE_DEACTIVATE_STAFF_CATEGORY_SUCCESS:
      return { ...state, isStaffCategoryLoading: false };
    case types.ACTIVATE_DEACTIVATE_STAFF_CATEGORY_FAILURE:
      return { ...state, isStaffCategoryLoading: false };

    // Staff Primary Location cases

    case types.FETCH_STAFF_PRIMARY_LOCATIONS_REQUEST:
      return { ...state, isStaffPrimaryLocationLoading: true };
    case types.FETCH_STAFF_PRIMARY_LOCATIONS_SUCCESS:
      return {
        ...state,
        isStaffPrimaryLocationLoading: false,
        staffPrimaryLocations: action.payload || [],
      };
    case types.FETCH_STAFF_PRIMARY_LOCATIONS_FAILURE:
      return {
        ...state,
        isStaffPrimaryLocationLoading: false,
        staffPrimaryLocations: [],
      };

    case types.FETCH_STAFF_PRIMARY_LOCATION_BY_ID_REQUEST:
      return { ...state, isStaffPrimaryLocationLoading: true };
    case types.FETCH_STAFF_PRIMARY_LOCATION_BY_ID_SUCCESS:
      return {
        ...state,
        isStaffPrimaryLocationLoading: false,
        selectedStaffPrimaryLocation: action.payload,
      };
    case types.FETCH_STAFF_PRIMARY_LOCATION_BY_ID_FAILURE:
      return { ...state, isStaffPrimaryLocationLoading: false };

    case types.SAVE_STAFF_PRIMARY_LOCATION_REQUEST:
      return { ...state, isStaffPrimaryLocationLoading: true };
    case types.SAVE_STAFF_PRIMARY_LOCATION_SUCCESS:
      return { ...state, isStaffPrimaryLocationLoading: false };
    case types.SAVE_STAFF_PRIMARY_LOCATION_FAILURE:
      return { ...state, isStaffPrimaryLocationLoading: false };

    case types.DELETE_STAFF_PRIMARY_LOCATION_REQUEST:
      return { ...state, isStaffPrimaryLocationLoading: true };
    case types.DELETE_STAFF_PRIMARY_LOCATION_SUCCESS:
      return { ...state, isStaffPrimaryLocationLoading: false };
    case types.DELETE_STAFF_PRIMARY_LOCATION_FAILURE:
      return { ...state, isStaffPrimaryLocationLoading: false };

    case types.ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_REQUEST:
      return { ...state, isStaffPrimaryLocationLoading: true };
    case types.ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_SUCCESS:
      return { ...state, isStaffPrimaryLocationLoading: false };
    case types.ACTIVATE_DEACTIVATE_STAFF_PRIMARY_LOCATION_FAILURE:
      return { ...state, isStaffPrimaryLocationLoading: false };

    //common cases
    //Modality cases
    case types.FETCH_MODALITY_REQUEST:
      return { ...state, isModalityLoading: true };
    case types.FETCH_MODALITY_SUCCESS:
      return {
        ...state,
        isModalityLoading: false,
        modality: action.payload?.lstModalities || action.payload || [],
      };
    case types.FETCH_MODALITY_FAILURE:
      return { ...state, isModalityLoading: false, modality: [] };

    case types.DELETE_MODALITY_REQUEST:
      return { ...state, isModalityLoading: true };
    case types.DELETE_MODALITY_SUCCESS:
      return {
        ...state,
        isModalityLoading: false,
        // modality: state.modality.filter(item => item.ModalityId !== action.payload)
      };
    case types.DELETE_MODALITY_FAILURE:
      return { ...state, isModalityLoading: false };

    case types.ACTIVATE_DEACTIVATE_MODALITY_REQUEST:
      return { ...state, isModalityLoading: true };
    case types.ACTIVATE_DEACTIVATE_MODALITY_SUCCESS:
      return { ...state, isModalityLoading: false };
    case types.ACTIVATE_DEACTIVATE_MODALITY_FAILURE:
      return { ...state, isModalityLoading: false };

    case types.SAVE_MODALITY_REQUEST:
      return { ...state, isModalityLoading: true };
    case types.SAVE_MODALITY_SUCCESS:
      return { ...state, isModalityLoading: false };
    case types.SAVE_MODALITY_FAILURE:
      return { ...state, isModalityLoading: false };

    case types.FETCH_MODALITY_BY_ID_REQUEST:
      return { ...state, isModalityLoading: true };
    case types.FETCH_MODALITY_BY_ID_SUCCESS:
      return {
        ...state,
        isModalityLoading: false,
        selectedModality: action.payload,
      };
    case types.FETCH_MODALITY_BY_ID_FAILURE:
      return { ...state, isModalityLoading: false, selectedModality: null };

    // Priority cases
    case types.FETCH_PRIORITY_REQUEST:
      return { ...state, isPriorityLoading: true };
    case types.FETCH_PRIORITY_SUCCESS:
      return {
        ...state,
        isPriorityLoading: false,
        Priority: action.payload?.lstPriorities || action.payload || [],
      };
    case types.FETCH_PRIORITY_FAILURE:
      return { ...state, isPriorityLoading: false, priority: [] };

    case types.DELETE_PRIORITY_REQUEST:
      return { ...state, isPriorityLoading: true };
    case types.DELETE_PRIORITY_SUCCESS:
      return { ...state, isPriorityLoading: false };
    case types.DELETE_PRIORITY_FAILURE:
      return { ...state, isPriorityLoading: false };

    case types.ACTIVATE_DEACTIVATE_PRIORITY_REQUEST:
      return { ...state, isPriorityLoading: true };
    case types.ACTIVATE_DEACTIVATE_PRIORITY_SUCCESS:
      return { ...state, isPriorityLoading: false };
    case types.ACTIVATE_DEACTIVATE_PRIORITY_FAILURE:
      return { ...state, isPriorityLoading: false };

    case types.SAVE_PRIORITY_REQUEST:
      return { ...state, isPriorityLoading: true };
    case types.SAVE_PRIORITY_SUCCESS:
      return { ...state, isPriorityLoading: false };
    case types.SAVE_PRIORITY_FAILURE:
      return { ...state, isPriorityLoading: false };

    case types.FETCH_PRIORITY_BY_ID_REQUEST:
      return { ...state, isPriorityLoading: true };
    case types.FETCH_PRIORITY_BY_ID_SUCCESS:
      return {
        ...state,
        isPriorityLoading: false,
        selectedPriority: action.payload,
      };
    case types.FETCH_PRIORITY_BY_ID_FAILURE:
      return { ...state, isPriorityLoading: false, selectedPriority: null };

    // Priority Bucket cases
    case types.FETCH_PRIORITY_BUCKETS_REQUEST:
      return { ...state, isPriorityBucketLoading: true };
    case types.FETCH_PRIORITY_BUCKETS_SUCCESS:
      return {
        ...state,
        isPriorityBucketLoading: false,
        priorityBuckets:
          action.payload?.lstPriorityBuckets || action.payload || [],
      };
    case types.FETCH_PRIORITY_BUCKETS_FAILURE:
      return { ...state, isPriorityBucketLoading: false, priorityBuckets: [] };

    // Specialty Cases cases - START
    case types.FETCH_SPECIALTY_CASES_REQUEST:
      return { ...state, isSpecialtyCasesLoading: true };
    case types.FETCH_SPECIALTY_CASES_SUCCESS:
      return {
        ...state,
        isSpecialtyCasesLoading: false,
        specialtyCases:
          action.payload?.lstSpecialityCase || action.payload || [],
      };
    case types.FETCH_SPECIALTY_CASES_FAILURE:
      return { ...state, isSpecialtyCasesLoading: false, specialtyCases: [] };

    case types.DELETE_SPECIALTY_CASES_REQUEST:
      return { ...state, isSpecialtyCasesLoading: true };
    case types.DELETE_SPECIALTY_CASES_SUCCESS:
      return { ...state, isSpecialtyCasesLoading: false };
    case types.DELETE_SPECIALTY_CASES_FAILURE:
      return { ...state, isSpecialtyCasesLoading: false };

    case types.SAVE_SPECIALTY_CASES_REQUEST:
      return { ...state, isSpecialtyCasesLoading: true };
    case types.SAVE_SPECIALTY_CASES_SUCCESS:
      return { ...state, isSpecialtyCasesLoading: false };
    case types.SAVE_SPECIALTY_CASES_FAILURE:
      return { ...state, isSpecialtyCasesLoading: false };

    case types.FETCH_SPECIALTY_CASES_BY_ID_REQUEST:
      return { ...state, isSpecialtyCasesLoading: true };
    case types.FETCH_SPECIALTY_CASES_BY_ID_SUCCESS:
      return {
        ...state,
        isSpecialtyCasesLoading: false,
        selectedSpecialtyCase: action.payload,
      };
    case types.FETCH_SPECIALTY_CASES_BY_ID_FAILURE:
      return {
        ...state,
        isSpecialtyCasesLoading: false,
        selectedSpecialtyCase: null,
      };

    case types.ACTIVATE_DEACTIVATE_SPECIALTY_CASES_REQUEST:
      return { ...state, isSpecialtyCasesLoading: true };
    case types.ACTIVATE_DEACTIVATE_SPECIALTY_CASES_SUCCESS:
      return { ...state, isSpecialtyCasesLoading: false };
    case types.ACTIVATE_DEACTIVATE_SPECIALTY_CASES_FAILURE:
      return { ...state, isSpecialtyCasesLoading: false };
    // Specialty Cases cases - END

    // Staffing Agency cases - START
    case types.FETCH_STAFFING_AGENCY_REQUEST:
      return { ...state, isStaffingAgencyLoading: true };
    case types.FETCH_STAFFING_AGENCY_SUCCESS:
      return {
        ...state,
        isStaffingAgencyLoading: false,
        staffingAgency:
          action.payload?.lstStaffingAgency ||
          action.payload ||
          [],
      };
    case types.FETCH_STAFFING_AGENCY_FAILURE:
      return { ...state, isStaffingAgencyLoading: false, staffingAgency: [] };

    case types.DELETE_STAFFING_AGENCY_REQUEST:
      return { ...state, isStaffingAgencyLoading: true };
    case types.DELETE_STAFFING_AGENCY_SUCCESS:
      return { ...state, isStaffingAgencyLoading: false };
    case types.DELETE_STAFFING_AGENCY_FAILURE:
      return { ...state, isStaffingAgencyLoading: false };

    case types.SAVE_STAFFING_AGENCY_REQUEST:
      return { ...state, isStaffingAgencyLoading: true };
    case types.SAVE_STAFFING_AGENCY_SUCCESS:
      return { ...state, isStaffingAgencyLoading: false };
    case types.SAVE_STAFFING_AGENCY_FAILURE:
      return { ...state, isStaffingAgencyLoading: false };

    case types.FETCH_STAFFING_AGENCY_BY_ID_REQUEST:
      return { ...state, isStaffingAgencyLoading: true };
    case types.FETCH_STAFFING_AGENCY_BY_ID_SUCCESS:
      return {
        ...state,
        isStaffingAgencyLoading: false,
        selectedStaffingAgency: action.payload,
      };
    case types.FETCH_STAFFING_AGENCY_BY_ID_FAILURE:
      return {
        ...state,
        isStaffingAgencyLoading: false,
        selectedStaffingAgency: null,
      };

    case types.ACTIVATE_DEACTIVATE_STAFFING_AGENCY_REQUEST:
      return { ...state, isStaffingAgencyLoading: true };
    case types.ACTIVATE_DEACTIVATE_STAFFING_AGENCY_SUCCESS:
      return { ...state, isStaffingAgencyLoading: false };
    case types.ACTIVATE_DEACTIVATE_STAFFING_AGENCY_FAILURE:
      return { ...state, isStaffingAgencyLoading: false };
    // Staffing Agency cases - END

    // Provider Document Types
    case types.FETCH_PROVIDER_DOCUMENTTYPES_REQUEST:
      return { ...state, isDocTypeLoading: true };
    case types.FETCH_PROVIDER_DOCUMENTTYPES_SUCCESS:
      return {
        ...state,
        isDocTypeLoading: false,
        docTypes: action.payload?.listRadDocType || [],
      };
    case types.FETCH_PROVIDER_DOCUMENTTYPES_FAILURE:
      return { ...state, isDocTypeLoading: false, subspecialities: [] };

    case types.FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_REQUEST:
      return { ...state, isDocTypeLoading: true };
    case types.FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_SUCCESS:
      return {
        ...state,
        isDocTypeLoading: false,
        selectedDocumentType: action.payload,
      };
    case types.FETCH_PROVIDER_DOCUMENTTYPE_BY_ID_FAILURE:
      return {
        ...state,
        isDocTypeLoading: false,
        selectedSubspeciality: null,
      };

    case types.SAVE_PROVIDER_DOCUMENTTYPE_REQUEST:
      return {
        ...state,
        isDocTypeLoading: true,
      };
    case types.SAVE_PROVIDER_DOCUMENTTYPE_SUCCESS:
      return {
        ...state,
        isDocTypeLoading: false,
      };
    case types.SAVE_PROVIDER_DOCUMENTTYPE_FAILURE:
      return {
        ...state,
        isDocTypeLoading: false,
      };

    case types.DELETE_PROVIDER_DOCUMENTTYPE_REQUEST:
      return {
        ...state,
        isDocTypeLoading: true,
      };
    case types.DELETE_PROVIDER_DOCUMENTTYPE_SUCCESS:
      return { ...state, isSubspecialityLoading: false };
    case types.DELETE_PROVIDER_DOCUMENTTYPE_FAILURE:
      return {
        ...state,
        isDocTypeLoading: false,
      };

    case types.ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_REQUEST:
      return {
        ...state,
        isDocTypeLoading: true,
      };
    case types.ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_SUCCESS:
      return { ...state, isDocTypeLoading: false };
    case types.ACTIVATE_DEACTIVATE_PROVIDER_DOCUMENTTYPE_FAILURE:
      return { ...state, isDocTypeLoading: false };

    // Provider Note Types
    case types.FETCH_PROVIDER_NOTETYPES_REQUEST:
      return { ...state, isNoteTypeLoading: true };
    case types.FETCH_PROVIDER_NOTETYPES_SUCCESS:
      return {
        ...state,
        isNoteTypeLoading: false,
        noteTypes: action.payload?.listRadNoteType || [],
      };
    case types.FETCH_PROVIDER_NOTETYPES_FAILURE:
      return { ...state, isNoteTypeLoading: false, noteTypes: [] };

    case types.FETCH_PROVIDER_NOTETYPE_BY_ID_REQUEST:
      return { ...state, isNoteTypeLoading: true };
    case types.FETCH_PROVIDER_NOTETYPE_BY_ID_SUCCESS:
      return {
        ...state,
        isNoteTypeLoading: false,
        selectedNoteType: action.payload,
      };
    case types.FETCH_PROVIDER_NOTETYPE_BY_ID_FAILURE:
      return { ...state, isNoteTypeLoading: false, selectedNoteType: null };

    case types.SAVE_PROVIDER_NOTETYPE_REQUEST:
      return { ...state, isNoteTypeLoading: true };
    case types.SAVE_PROVIDER_NOTETYPE_SUCCESS:
      return { ...state, isNoteTypeLoading: false };
    case types.SAVE_PROVIDER_NOTETYPE_FAILURE:
      return { ...state, isNoteTypeLoading: false };

    case types.DELETE_PROVIDER_NOTETYPE_REQUEST:
      return { ...state, isNoteTypeLoading: true };
    case types.DELETE_PROVIDER_NOTETYPE_SUCCESS:
      return { ...state, isNoteTypeLoading: false };
    case types.DELETE_PROVIDER_NOTETYPE_FAILURE:
      return { ...state, isNoteTypeLoading: false };

    case types.ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_REQUEST:
      return { ...state, isNoteTypeLoading: true };
    case types.ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_SUCCESS:
      return { ...state, isNoteTypeLoading: false };
    case types.ACTIVATE_DEACTIVATE_PROVIDER_NOTETYPE_FAILURE:
      return { ...state, isNoteTypeLoading: false };

    //common cases
    case types.UPDATE_DROPDOWN_MANAGEMENT_REDUCER:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default dropdownMgmtReducer;
